import { IconButton } from '@material-ui/core'
import { isEqual } from 'lodash'
import { memo, useCallback, useEffect, useState } from 'react'
import { MdDelete } from 'react-icons/md'
import { metodoPrograma } from '../../../../components/api'
import Table from '../../../../components/Table'
import Edicao from './Edicao'

const UsuariosDoContratante = () => {
  const [listaContratante, setListaContratante] = useState([])

  const buscaLista = useCallback(async () => {
    const res = await metodoPrograma('listaContratante')
    setListaContratante(res.lista || [])
  }, [])

  useEffect(() => {
    buscaLista()
  }, [buscaLista])

  const exclui = (idUsuario) => async (e) => {
    e.stopPropagation()
    if (
      !window.confirm('Mas você tem CERTEZA que deseja excluir este usuário???')
    )
      return
    await metodoPrograma('exclui', { idUsuario })
    await buscaLista()
  }

  const [tela, setTela] = useState('lista')
  const [programaAberto, setProgramaAberto] = useState([])

  // useEffect(() => {
  //   switch (tela) {
  //     case 'lista':
  //       setFerramentas(<Tooltip title='Adicionar Programa'>
  //         <IconButton onClick={() => setTela('opcoes')}>
  //           <MdAdd/>
  //         </IconButton>
  //       </Tooltip>
  //       );
  //       break;
  //     case 'opcoes':
  //       setFerramentas(
  //         <>
  //           <Tooltip title='Voltar'>
  //             <IconButton onClick={voltar}>
  //               <MdArrowBack/>
  //             </IconButton>
  //           </Tooltip>
  //           <Tooltip title='Tipos de Usuário'>
  //             <IconButton onClick={() => setTela('tiposUsuario')}>
  //               <FaUsersCog/>
  //             </IconButton>
  //           </Tooltip>
  //           <Tooltip title='Usuários do Contratante'>
  //             <IconButton onClick={() => setTela('usuariosDoContratante')}>
  //               <HiOutlineUserGroup/>
  //             </IconButton>
  //           </Tooltip>
  //           <Tooltip title='Perfil de Permissão'>
  //             <IconButton onClick={() => setTela('usuariosDoContratante')}>
  //               <FaUserShield/>
  //             </IconButton>
  //           </Tooltip>

  //         </>
  //         );
  //       break;
  //     default:
  //       break;
  //   }
  // }, [tela]);

  const voltar = () => {
    buscaLista()
    setTela('lista')
    setProgramaAberto(undefined)
  }

  const handleClick = async (_, linha) => {
    setProgramaAberto(linha)
    setTela('opcoes')
  }
  return (
    <>
      {tela === 'lista' ? (
        <>
          <h4>Listagem de Usuários do Contratante</h4>
          <Table
            dados={listaContratante}
            head={['ID', 'Descrição', 'Responsável', 'Inclusão', '']}
            line={(l) => [l[0], l[1], l[2], l[9], '']}
            columnOptions={[
              {
                alias: 4,
                customJsx: ({ itemFormatado, linhaOriginal }) =>
                  linhaOriginal[3] ? (
                    ''
                  ) : (
                    <IconButton size="small" onClick={exclui(itemFormatado)}>
                      <MdDelete />
                    </IconButton>
                  ),
              },
            ]}
            onClick={handleClick}
          />
        </>
      ) : (
        <Edicao {...{ programaAberto, voltar }} />
      )}
    </>
  )
}

export default memo(UsuariosDoContratante, isEqual)
